const payload: Record<string, any> = {};

export default payload;
